module.exports = __webpack_public_path__ + "static/media/abonnements.1f4488e4.png";